import React from "react";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import { TextField } from "@outpave/ds";
import { fieldErrorText, isTouchedAndError } from "utils/formikFieldError";
import { CardPolicy } from "utils/cards/cardFormUtils";

const CardPresetTextBox: React.FC<{ formik: FormikProps<CardPolicy> }> = ({
  formik,
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      name="nameOfPreset"
      label={t("Name of Preset")}
      placeholder={t("PlatinumCard") as string}
      fullWidth
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      // The form seeds this as null, so the input needs a string to stay
      // controlled from the first render.
      value={formik.values["nameOfPreset"] ?? ""}
      error={isTouchedAndError(formik, "nameOfPreset")}
      errorText={fieldErrorText(formik, "nameOfPreset")}
    />
  );
};

export default CardPresetTextBox;
